var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", style: _vm.style },
    [
      _c(
        "Signature",
        {
          attrs: { name: _vm.currentUser.nombre, closable: _vm.closable },
          on: {
            close: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _vm._t("default", [
            _c("div", { staticClass: "data-item" }, [
              _vm._v(_vm._s(_vm.currentUser.cargo))
            ]),
            _c("div", { staticClass: "data-item" }, [
              _vm._v(_vm._s(_vm.currentUser.iut))
            ]),
            _c("div", { staticClass: "data-item" }, [
              _vm._v(_vm._s(_vm.company.fantasia))
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }